import { render } from "./TitleBox.vue?vue&type=template&id=4f09ea0c&scoped=true"
import script from "./TitleBox.vue?vue&type=script&lang=js"
export * from "./TitleBox.vue?vue&type=script&lang=js"

import "./TitleBox.vue?vue&type=style&index=0&id=4f09ea0c&scoped=true&lang=css"

import exportComponent from "/Users/apple/Documents/Programing/sonak/sonak_2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f09ea0c"]])

export default __exports__